export default "__VITE_ASSET__DyMvKIE___"